import { render } from "./UpperBar.vue?vue&type=template&id=4aed2547"
import script from "./UpperBar.vue?vue&type=script&lang=js"
export * from "./UpperBar.vue?vue&type=script&lang=js"

import "./UpperBar.vue?vue&type=style&index=0&id=4aed2547&lang=scss"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__